import { useNotificationStream } from '@porotutu/react/api'
import type { InboxEntry } from '@porotutu/react/components/NotificationBell/Inbox'
import { NotificationBell as Bell } from '@porotutu/react/components/NotificationBell/NotificationBell'
import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { NOTIFICATIONS } from '@/api/keys'
import {
  markAllRead,
  type NotificationFrame,
  notificationsQuery,
  openNotificationStream,
} from '@/api/notifications'

export function NotificationEntryLink({
  entry,
  label,
  close,
}: {
  entry: InboxEntry
  label: string
  close: () => void
}): ReactNode {
  return (
    <Link to="/customers/$id" params={{ id: entry.subject_id }} onClick={close}>
      {label}
    </Link>
  )
}

export function NotificationBell() {
  useNotificationStream<NotificationFrame>({
    queryKey: NOTIFICATIONS,
    open: openNotificationStream,
  })

  return (
    <Bell
      inboxQuery={notificationsQuery}
      markAllRead={markAllRead}
      invalidates={NOTIFICATIONS}
      entryLink={(entry, label, close) => (
        <NotificationEntryLink entry={entry} label={label} close={close} />
      )}
    />
  )
}
